import { render, staticRenderFns } from "./SelectShops.vue?vue&type=template&id=84b48ce4&scoped=true"
import script from "./SelectShops.vue?vue&type=script&lang=js"
export * from "./SelectShops.vue?vue&type=script&lang=js"
import style0 from "./SelectShops.vue?vue&type=style&index=0&id=84b48ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b48ce4",
  null
  
)

export default component.exports